module.exports = __webpack_public_path__ + "img/thumbnail_AfricanPenguin_j_normal.29d1805e.png";